import { Card, Row, Spin, Tag } from 'antd';
import React, { useEffect, useState } from 'react';
import UTILS from 'utils';
import Service from '../../Services';
import './Headers.scss';

const Headers = ({ type, linkTemplate }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    Service.getHeaders(type)
      .then((data) => {
        setData(data.items);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <div key='headers'>
      <Spin indicator={UTILS.CLASS.LOADER} spinning={loading}>
        <Card
          className='headers-card'
          title='Các cột hợp lệ (Bắt buộc theo thứ tự và không chứa tên cột trong file)'
          extra={
            <a href={linkTemplate} target={'_blank'}>
              Tải Template
            </a>
          }
        >
          <Row>
            {data.map((entry, i) => {
              return (
                <Tag key={i} color='orange'>
                  {entry}
                </Tag>
              );
            })}
          </Row>
        </Card>
      </Spin>
    </div>
  );
};

export default Headers;
